import { useTranslation } from "react-i18next";
import { ReactComponent as Logo } from "shared/assets/images/logo-strm-horizontal.svg";
import { ReactComponent as LogoTemp } from "shared/assets/images/logo-strm.svg";
import { ReactComponent as IconMenu } from "shared/assets/images/menu.svg";
import { ReactComponent as IconMeusDados } from "shared/assets/images/icon-meus-dados.svg";
import IconMeusDadosSrc from "shared/assets/images/icon-meus-dados.svg";
import { ReactComponent as IconArtistManagement } from "shared/assets/images/icon-artist-management.svg";
import { ReactComponent as IconLogout } from "shared/assets/images/icon-logout.svg";
import { ReactComponent as HomeIcon } from "shared/assets/images/icon-home.svg";
import { ReactComponent as QuincyIcon } from "shared/assets/images/quincy-icon.svg";
import { ReactComponent as IconMetas } from "shared/assets/images/icon-metas.svg";
import { ReactComponent as DiagnosticoIcon } from "shared/assets/images/icon-diagnostic.svg";
import { ReactComponent as MenuIcon } from "shared/assets/images/icon-menu.svg";
import { useState, useRef, useMemo, useCallback } from "react";
import { Layout, Menu, Popover } from "antd";
import { isMobile } from "react-device-detect";
import ContentMenu from "./MenuContent";
import { Link, useHistory } from "react-router-dom";
import { logout } from "shared/helpers/auth-functions";
import { useSelector } from "react-redux";
import "./MenuLateral.scss";
import ArtistMetrics from "../artist-metrics/ArtistMetrics";
import { useFlags } from "launchdarkly-react-client-sdk";
import { dataLayerClickedEvent } from "event-tracker/gtm-events";
import { MenuButtonClickEventName } from "event-tracker/button-click-event-name";
import SubscriptionDefaultCTA from "../subscription/SubscriptionDefaultCTA";
import MyPlan from "../subscription/MyPlan";
import { isEnableFullDiagnostic } from "shared/helpers/full-diagnostic-helpers";
import CustomLevelSvg from "../custom-level-svg/CustomLevelSvg";
import { UserState } from "explorer/reducers/users";
import { UserTypeEnum } from "shared/enums/UserTypeEnum";

const { Header } = Layout;

declare global {
  interface Window {
    flutter_inappwebview: any;
  }
}

const MenuLateral: React.FC = () => {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [isMainMenuOpen, setIsMainMenuOpen] = useState<boolean>(false);
  const [openProfile, setOpenProfile] = useState<boolean>(false);
  const profileMenuRef = useRef<HTMLDivElement | null>(null);
  const { userArtist } = useSelector((state: any) => state.artists);
  const { loggedUser } = useSelector((state: UserState) => state.users);
  let { titulo } = t(
    `pages.EstagioArtista.estagio.${userArtist?.stage || 0}`
  ) as any;
  const history = useHistory();
  const { metricsMenu, showHome } = useFlags();

  const signOutClickHandler = useCallback(() => logout(false), []);

  const profileMenuItems = useMemo(() => {
    const items = [
      {
        label: (
          <Link to="/meus-dados">{t("components.MenuLateral.meusDados")}</Link>
        ),
        key: "/meus-dados",
        icon: <IconMeusDados />,
      },
      {
        label: t("components.MenuLateral.sair"),
        key: "logout",
        icon: <IconLogout />,
        onClick: signOutClickHandler,
      },
    ];
    if (
      loggedUser?.typeAccess === UserTypeEnum.Labels ||
      loggedUser?.typeAccess === UserTypeEnum.AdminStrm
    ) {
      return [
        {
          label: (
            <Link to="/gerenciamento-artistas">
              {t("components.MenuLateral.gerenciamentoArtistas")}
            </Link>
          ),
          key: "/gerenciamento-artistas",
          icon: <IconArtistManagement />,
        },
        ...items,
      ];
    }

    return items;
  }, [loggedUser?.typeAccess, t, signOutClickHandler]);

  const handleMouseEnter = () => {
    setCollapsed(false);
  };

  const handleMouseLeave = () => {
    setCollapsed(true);
  };

  const closeProfileMenu = () => {
    setOpenProfile(false);
  };

  const onClickOpenMenu = () => {
    setMenuOpen(true);
    dataLayerClickedEvent(MenuButtonClickEventName.OPEN_MENU, {
      businessContext: "TOOLBAR",
      platformContext: "S4A",
    });
  };

  const onClickOpenProfile = () => {
    setOpenProfile(!openProfile);
    if (openProfile) {
      dataLayerClickedEvent(MenuButtonClickEventName.PROFILE, {
        businessContext: "TOOLBAR",
        platformContext: "S4A",
      });
    }
  };

  // useEffect(() => {
  //   if (!openProfile) return;
  //   function handleClickOutside(event: MouseEvent) {
  //     if (
  //       profileMenuRef.current &&
  //       !profileMenuRef.current.contains(event.target as Node)
  //     ) {
  //       setOpenProfile(false);
  //     }
  //   }
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [openProfile]);

  if (isMobile)
    return (
      <>
        <div
          className={`menu content-menu  mobile ${
            collapsed ? "collapsed" : ""
          }`}
        >
          <div className="menu-top">
            {!metricsMenu && (
              <div className="item">
                <LogoTemp
                  style={{ width: 48 }}
                  onClick={() => history.push("/")}
                />
              </div>
            )}
            {metricsMenu && <ArtistMetrics />}

            <div
              className="last"
              style={{ marginLeft: 6 }}
              onClick={onClickOpenProfile}
            >
              {userArtist ? (
                <div className="image">
                  <img src={userArtist?.profileImage} alt="" />
                  <span className="estagio">{userArtist?.stage}</span>
                </div>
              ) : (
                <div className="image">
                  <img src={IconMeusDadosSrc} alt="" />
                  <span className="estagio">-</span>
                </div>
              )}
            </div>
          </div>
          {openProfile && (
            <div
              ref={profileMenuRef}
              style={{ width: "100%", backgroundColor: "#242366" }}
            >
              <div className="menu-list">
                <div style={{ padding: "0 16px" }}>
                  <MyPlan />
                </div>
                <div
                  className={`menu-item${
                    history?.location?.pathname === "/gerenciamento-artistas"
                      ? " selected"
                      : ""
                  }`}
                  hidden={
                    loggedUser.typeAccess !== UserTypeEnum.Labels &&
                    loggedUser.typeAccess !== UserTypeEnum.AdminStrm
                  }
                >
                  <Link to="/gerenciamento-artistas" onClick={closeProfileMenu}>
                    <IconArtistManagement />
                    <span>
                      {t("components.MenuLateral.gerenciamentoArtistas")}
                    </span>
                  </Link>
                </div>
                <div
                  className={`menu-item${
                    history?.location?.pathname === "/meus-dados"
                      ? " selected"
                      : ""
                  }`}
                >
                  <Link to="/meus-dados" onClick={closeProfileMenu}>
                    <IconMeusDados />
                    <span>{t("components.MenuLateral.meusDados")}</span>
                  </Link>
                </div>

                <div className="menu-item" onClick={signOutClickHandler}>
                  <IconLogout />
                  <span>{t("components.MenuLateral.sair")}</span>
                </div>
              </div>
            </div>
          )}
        </div>
        {!menuOpen && (
          <nav className="bottom-nav-bar">
            <Link
              to={showHome ? "/" : "/estagio"}
              className="nav-btn"
              onClick={closeProfileMenu}
            >
              <HomeIcon stroke="#bcb8f7" />
            </Link>
            <Link to="/metas" className="nav-btn" onClick={closeProfileMenu}>
              <IconMetas stroke="#bcb8f7" />
            </Link>
            {isEnableFullDiagnostic(userArtist) && (
              <Link
                to="/diagnosticos"
                className="nav-btn"
                onClick={closeProfileMenu}
              >
                <DiagnosticoIcon stroke="#bcb8f7" />
              </Link>
            )}
            <Link to="/quincy" className="nav-btn" onClick={closeProfileMenu}>
              <QuincyIcon fill="#bcb8f7" width={21} />
            </Link>
            <button className="nav-btn" onClick={onClickOpenMenu}>
              <IconMenu fill="#bcb8f7" />
            </button>
          </nav>
        )}
        {menuOpen && (
          <ContentMenu onCloseMenu={() => setMenuOpen(false)} fullScreen />
        )}
      </>
    );

  return (
    <Header
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="menu"
      style={{
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 9999,
        width: "100%",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
        onClick={() => history.push("/")}
      >
        <Logo />
        <span
          style={{
            marginTop: 8,
            marginLeft: 12,
            color: "#F2F2F2",
            fontSize: 12,
            lineHeight: "100%",
          }}
        >
          for artists
        </span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {metricsMenu && (
          <div className="artist-metrics-wrapper">
            <ArtistMetrics />
          </div>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            cursor: "pointer",
          }}
          onClick={() => history.push("/estagio")}
        >
          <CustomLevelSvg level={userArtist?.stage || 0} />
          <span className="body-regular" style={{ fontWeight: 700 }}>
            {titulo}
          </span>
        </div>
        <div style={{ width: 100 }}>
          <span
            style={{
              marginBottom: 4,
              lineHeight: 1,
              display: "block",
            }}
            className="body-small"
          >
            {`${(userArtist?.stagePercentual || 0).toFixed(0)}% `}
          </span>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                height: 4,
                width: `${userArtist?.stagePercentual || 0}%`,
                backgroundColor: "#00D88A",
                borderRadius:
                  userArtist?.stagePercentual === 100
                    ? "3px"
                    : "3px 0px 0px 3px",
              }}
            />
            <div
              style={{
                height: 4,
                width: `${100 - (userArtist?.stagePercentual || 0)}%`,
                backgroundColor: "#1B1A4C",
                borderRadius: "0px 3px 3px 0px",
              }}
            />
          </div>
        </div>
        <SubscriptionDefaultCTA />
        <Popover
          classNames={{
            root: "popover-menu",
          }}
          trigger={"click"}
          open={isMainMenuOpen}
          onOpenChange={(open) => {
            setIsMainMenuOpen(open);
            if (open) {
              dataLayerClickedEvent(MenuButtonClickEventName.PROFILE, {
                businessContext: "TOOLBAR",
                platformContext: "S4A",
              });
            }
          }}
          content={<ContentMenu onCloseMenu={() => setIsMainMenuOpen(false)} />}
        >
          <span style={{ display: "flex", cursor: "pointer" }}>
            <MenuIcon />
          </span>
        </Popover>

        <Popover
          classNames={{
            root: "popover-menu",
          }}
          styles={{
            root: {
              width: "fit-content",
              top: 60,
            },
          }}
          arrowContent={null}
          trigger={"click"}
          onOpenChange={(open) => {
            if (open) {
              dataLayerClickedEvent(MenuButtonClickEventName.OPEN_MENU, {
                businessContext: "TOOLBAR",
                platformContext: "S4A",
              });
            }
          }}
          content={
            <div>
              <MyPlan />
              <Menu
                mode="vertical"
                selectedKeys={[history?.location?.pathname]}
                items={profileMenuItems}
              />
            </div>
          }
        >
          {userArtist?.id ? (
            <div className="image">
              <img src={userArtist?.profileImage} alt="" />
            </div>
          ) : (
            <div className="image">
              <img src={IconMeusDadosSrc} alt="" />
              <span className="estagio">-</span>
            </div>
          )}
        </Popover>
      </div>
    </Header>
  );
};

export default MenuLateral;
